var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00099 15.0003L15.001 9.00031M11.001 6.00031L11.464 5.46431C12.4018 4.52663 13.6737 3.99991 14.9998 4C16.326 4.00009 17.5978 4.527 18.5355 5.46481C19.4732 6.40261 19.9999 7.6745 19.9998 9.00066C19.9997 10.3268 19.4728 11.5986 18.535 12.5363L18.001 13.0003M13.001 18.0003L12.604 18.5343C11.655 19.472 10.3746 19.9979 9.04049 19.9979C7.70636 19.9979 6.42599 19.472 5.47699 18.5343C5.0091 18.072 4.63762 17.5215 4.38409 16.9146C4.13055 16.3077 4 15.6565 4 14.9988C4 14.3411 4.13055 13.6899 4.38409 13.083C4.63762 12.4761 5.0091 11.9256 5.47699 11.4633L6.00099 11.0003",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/LinkIcon.f42262d548de5e28c73cff928e8905a2.svg";
export { ForwardRef as ReactComponent };